import React from 'react'

import { Select, SelectOption } from 'ui/components/Select'
import { ColorScheme } from 'ui/styling/baseVariables/colors/colorPalette'

export const SelectDefaultValue: React.FC<{
    value: FieldDto['default_value']
    onChange: (value: FieldDto['default_value']) => void
    field: FieldDto
}> = ({ value, onChange, field }) => {
    const fieldOptions = field.options?.options ?? []
    // if the field type is being modified, selectedType is set - we want to show the default config for the new field
    // type, even before saved
    const effectiveFieldType = (field as any).selectedType ?? field.type

    return (
        <Select
            multiSelect={effectiveFieldType === 'multi_select'}
            value={value?.value}
            onChange={(value: any) => onChange({ type: 'constant', value })}
        >
            {fieldOptions.map((option) => (
                <SelectOption
                    color={option.color as ColorScheme}
                    key={option.id}
                    value={option.value ?? ''}
                    label={option.label}
                />
            ))}
        </Select>
    )
}
